import { type MenuTextMatch } from '@lexical/react/LexicalTypeaheadMenuPlugin'
import { type EmailVariable } from './emailTemplateTypes'

export interface VariableGroup {
  title: string
  variables: EmailVariable[]
}

const OTHER = 'Other'

const titleOf = (variable: EmailVariable): string => {
  const title = variable.group?.trim() ?? ''
  return title === '' || title.toLowerCase() === OTHER.toLowerCase() ? OTHER : title
}

export const groupVariables = (variables: EmailVariable[]): VariableGroup[] => {
  const titles = Array.from(new Set(variables.map(titleOf))).filter((title) => title !== OTHER)
  const grouped = titles.map((title) => ({ title, variables: variables.filter((variable) => titleOf(variable) === title) }))
  const ungrouped = variables.filter((variable) => titleOf(variable) === OTHER)
  return ungrouped.length ? [...grouped, { title: OTHER, variables: ungrouped }] : grouped
}

export const orderVariables = (variables: EmailVariable[]): EmailVariable[] => groupVariables(variables).flatMap((group) => group.variables)

export const matchVariables = (variables: EmailVariable[], query: string): EmailVariable[] => {
  const needle = query.trim().toLowerCase()
  return needle ? variables.filter((variable) => variable.label.toLowerCase().includes(needle) || variable.name.includes(needle)) : variables
}

const VARIABLE_TRIGGER = /(^|[\s(])(\{\{?)([\w ]{0,40})$/

export const matchVariableTrigger = (textBeforeCaret: string): MenuTextMatch | null => {
  const match = VARIABLE_TRIGGER.exec(textBeforeCaret)
  return match ? { leadOffset: match.index + match[1].length, matchingString: match[3], replaceableString: `${match[2]}${match[3]}` } : null
}

export const variableOptionId = (listboxId: string, index: number): string => `${listboxId}-option-${index}`
